import { logout } from 'src/api/endpoints/loginWeb';
import { handleApiRequest } from 'src/api/handleApiRequest';

import {
  useActivationStore,
  useDashboardStore,
  useGeneralPurposeModalStore,
  useEducationLibraryStore,
  useMessagesStore,
  useRealtimeStore,
  useSessionStore,
  useSurveyStore
} from 'src/store';

export async function userLogout($q) {
  $q.loading.show();

  // Tear down the live SignalR connection before clearing session state so the
  // server doesn't keep pushing notifications to a logged-out user.
  try { await useRealtimeStore().stop(); } catch { /* swallow */ }

  // hit the server to logout
  await handleApiRequest(() => logout(), null, $q)
    .catch((error) => {
      console.error("Error", error)
    })
    .finally(() => $q.loading.hide());

  // logout logics
  useActivationStore().clear();
  useSessionStore().clear();
  useDashboardStore().clear();
  useGeneralPurposeModalStore().setModalMutation(null);
  useEducationLibraryStore().clear();
  useMessagesStore().clear();
  useSurveyStore().clear();
}

export function resetProcedureRelatedState() {
  useActivationStore().clear();
  useDashboardStore().clear();
  useGeneralPurposeModalStore().setModalMutation(null);
  useEducationLibraryStore().clear();
  useMessagesStore().clear();
  useSurveyStore().clear();
}
